module.exports = __webpack_public_path__ + "img/EA.f7d62886.png";